import { Http } from '@/lib/http';
export class LoanReportingSettings extends Http {
  constructor() {
    super();
    this.endpoint = 'loan-pro/settings/loan-reporting-categories/';
  }
  getAll() {
    return this.httpClient().get(`${this.endpoint}`);
  }
  create(payload) {
    return this.httpClient().post(`${this.endpoint}`, payload);
  }
  update(payload) {
    return this.httpClient().patch(`${this.endpoint}${payload.id}`, payload);
  }
  remove(id) {
    return this.httpClient().delete(`${this.endpoint}${id}`);
  }
}
